export default __webpack_public_path__ + "static/media/hero-level-5-chars-mob.7ab80662.webp";